// Gedeelde beweging voor dashboard en webshop, naar Apple's "Designing Fluid Interfaces":
// veren i.p.v. vaste duur, standaard kritisch gedempt (geen overshoot).

// Framer Motion: `bounce: 0` = dampingratio 1, `duration` ≈ Apple's "response".
export const spring = { type: "spring", bounce: 0, duration: 0.4 };
export const snappySpring = { type: "spring", bounce: 0, duration: 0.3 };

export const prefersReducedMotion = () =>
   typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const supportsLinearEasing =
   typeof CSS !== "undefined" && CSS.supports?.("animation-timing-function", "linear(0, 1)");

// Veer als CSS `linear()`-easing voor de Web Animations API.
// response: seconden (lager = sneller), dampingRatio: 1 = geen overshoot,
// velocity: beginsnelheid relatief t.o.v. de af te leggen afstand (per seconde),
// zodat een animatie na een sleepbeweging de snelheid van de vinger overneemt.
export function springAnimation({ response = 0.4, dampingRatio = 1, velocity = 0 } = {}) {
   const omega = (2 * Math.PI) / response;
   const u0 = 1; // resterende afstand (genormaliseerd)
   const v0 = -velocity; // u daalt wanneer de beweging richting doel gaat

   const displacement = (t) => {
      if (dampingRatio >= 1) {
         return (u0 + (v0 + omega * u0) * t) * Math.exp(-omega * t);
      }
      const wd = omega * Math.sqrt(1 - dampingRatio * dampingRatio);
      const decay = Math.exp(-dampingRatio * omega * t);
      return decay * (u0 * Math.cos(wd * t) + ((v0 + dampingRatio * omega * u0) / wd) * Math.sin(wd * t));
   };

   // Looptijd = tot de veer binnen 0,1% van het doel tot rust komt.
   const step = 1 / 60;
   let duration = step;
   let quiet = 0;
   while (duration < 2) {
      quiet = Math.abs(displacement(duration)) < 0.001 ? quiet + 1 : 0;
      if (quiet >= 6) break;
      duration += step;
   }

   if (!supportsLinearEasing) {
      return { duration: duration * 1000, easing: "cubic-bezier(0.32, 0.72, 0, 1)" };
   }

   const points = [];
   const samples = Math.min(60, Math.max(12, Math.round(duration / step)));
   for (let i = 0; i <= samples; i++) {
      const progress = 1 - displacement((duration * i) / samples);
      points.push(Number(progress.toFixed(4)));
   }
   points[points.length - 1] = 1;
   return { duration: duration * 1000, easing: `linear(${points.join(", ")})` };
}

// Apple's projectiefunctie: waar een beweging met deze snelheid (px/s) tot rust komt.
export function project(velocity, decelerationRate = 0.998) {
   return ((velocity / 1000) * decelerationRate) / (1 - decelerationRate);
}

// Weerstand voorbij een grens: hoe verder, hoe minder het element volgt.
export function rubberband(overshoot, dimension, constant = 0.55) {
   return (overshoot * dimension * constant) / (dimension + constant * Math.abs(overshoot));
}
